<div [class]="classes" [ngStyle]="{ 'min-height': shouldUseCalcolatedHeight ? 'calc(100% - 70px)' : '100%' }">
  <ng-content></ng-content>
</div>
